import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import styles from "../WordCount/WordCount.css";

import calculateAtomicUnitCounts from "editor/utils/calculateAtomicUnitCounts";
import isEditorActive from "editor/utils/isEditorActive";

export default function AtomicUnitCounts({ editorState, hasPrimaryImage }) {
  const [
    characterCount,
    // lineBreakCount,
  ] = calculateAtomicUnitCounts(editorState, hasPrimaryImage);

  const className = classNames(styles.root, {
    [styles.hidden]: !isEditorActive(editorState),
  });

  return (
    <div className={className}>
      <h6 className={styles.title}>Atomic unit</h6>
      <p>
        {`${characterCount} character${characterCount === 1 ? "" : "s"} left`}
      </p>
      {/* TODO: We are hiding the line break count until editors become more
      comfortable with just the character count for the atomic unit */}
      {/* <p> */}
      {/*   {`${lineBreakCount} line break${lineBreakCount === 1 ? "" : "s"} left`} */}
      {/* </p> */}
    </div>
  );
}

AtomicUnitCounts.propTypes = {
  editorState: PropTypes.object.isRequired,
  hasPrimaryImage: PropTypes.bool,
};
